// Textos do Fundo e arrendamentos da Farm (02/11/2026), coletados por glob em
// core/i18n/messages.ts.
const pt = {
  'farm.fundo.titulo': 'Fundo e arrendamentos',
  'farm.fundo.cnpj': 'CNPJ',
  'farm.fundo.constituidoEm': 'Constituído em {{data}}',
  'farm.fundo.hectares': '{{n}} ha',
  'farm.fundo.num.imoveis': 'Imóveis',
  'farm.fundo.num.area': 'Área',
  'farm.fundo.num.arrendamentos': 'Arrendamentos vigentes',
  'farm.fundo.num.valorAnual': 'Arrendamento ao ano',
  'farm.fundo.aba.dados': 'Dados',
  'farm.fundo.aba.imoveis': 'Imóveis',
  'farm.fundo.aba.arrendamentos': 'Arrendamentos',
  'farm.fundo.aba.documentos': 'Documentos',
  'farm.fundo.administradora': 'Administradora',
  'farm.fundo.gestora': 'Gestora',
  'farm.fundo.naoInformada': 'Não informada nos documentos',
  'farm.fundo.administradores': 'Administradores',
  'farm.fundo.col.imovel': 'Imóvel',
  'farm.fundo.col.valor': 'Valor anual',
  'farm.fundo.col.documento': 'Contrato',
  'farm.fundo.arrendataria': 'Arrendatária',
  'farm.fundo.porHectare': '{{valor}} por ha',
  'farm.fundo.novoArrendamento': 'Novo arrendamento',
  'farm.fundo.semArrendamento': 'Nenhum contrato de arrendamento',
  'farm.fundo.ajudaArrendamentos': 'Os contratos entre o fundo, que arrenda, e a operação, que toma as fazendas. Cada contrato mora na pasta Arrendamentos dos Documentos, com as versões; a vigência avisa 60 dias antes de vencer.',
}

const en: typeof pt = {
  'farm.fundo.titulo': 'Fund and leases',
  'farm.fundo.cnpj': 'Company number',
  'farm.fundo.constituidoEm': 'Established on {{data}}',
  'farm.fundo.hectares': '{{n}} ha',
  'farm.fundo.num.imoveis': 'Properties',
  'farm.fundo.num.area': 'Area',
  'farm.fundo.num.arrendamentos': 'Active leases',
  'farm.fundo.num.valorAnual': 'Lease per year',
  'farm.fundo.aba.dados': 'Data',
  'farm.fundo.aba.imoveis': 'Properties',
  'farm.fundo.aba.arrendamentos': 'Leases',
  'farm.fundo.aba.documentos': 'Documents',
  'farm.fundo.administradora': 'Administrator',
  'farm.fundo.naoInformada': 'Not stated in the documents',
  'farm.fundo.gestora': 'Manager',
  'farm.fundo.administradores': 'Officers',
  'farm.fundo.col.imovel': 'Property',
  'farm.fundo.col.valor': 'Annual value',
  'farm.fundo.col.documento': 'Agreement',
  'farm.fundo.arrendataria': 'Lessee',
  'farm.fundo.porHectare': '{{valor}} per ha',
  'farm.fundo.novoArrendamento': 'New lease',
  'farm.fundo.semArrendamento': 'No lease agreement',
  'farm.fundo.ajudaArrendamentos': 'The agreements between the fund, which leases out, and the operation, which takes the farms. Each agreement lives in the Leases folder of Documents, with its versions; the validity warns 60 days before expiry.',
}

const es: typeof pt = {
  'farm.fundo.titulo': 'Fondo y arrendamientos',
  'farm.fundo.cnpj': 'CNPJ',
  'farm.fundo.constituidoEm': 'Constituido el {{data}}',
  'farm.fundo.hectares': '{{n}} ha',
  'farm.fundo.num.imoveis': 'Inmuebles',
  'farm.fundo.num.area': 'Área',
  'farm.fundo.num.arrendamentos': 'Arrendamientos vigentes',
  'farm.fundo.num.valorAnual': 'Arrendamiento al año',
  'farm.fundo.aba.dados': 'Datos',
  'farm.fundo.aba.imoveis': 'Inmuebles',
  'farm.fundo.aba.arrendamentos': 'Arrendamientos',
  'farm.fundo.aba.documentos': 'Documentos',
  'farm.fundo.administradora': 'Administradora',
  'farm.fundo.naoInformada': 'No consta en los documentos',
  'farm.fundo.gestora': 'Gestora',
  'farm.fundo.administradores': 'Administradores',
  'farm.fundo.col.imovel': 'Inmueble',
  'farm.fundo.col.valor': 'Valor anual',
  'farm.fundo.col.documento': 'Contrato',
  'farm.fundo.arrendataria': 'Arrendataria',
  'farm.fundo.porHectare': '{{valor}} por ha',
  'farm.fundo.novoArrendamento': 'Nuevo arrendamiento',
  'farm.fundo.semArrendamento': 'Ningún contrato de arrendamiento',
  'farm.fundo.ajudaArrendamentos': 'Los contratos entre el fondo, que arrienda, y la operación, que toma las haciendas. Cada contrato vive en la carpeta Arrendamientos de Documentos, con sus versiones; la vigencia avisa 60 días antes del vencimiento.',
}

export default { pt, en, es }
